module.exports = __webpack_public_path__ + "static/img/tool-img02.58a2db5.jpg";